import { Inline, Table, Text } from "@sembark-travel/ui-base"
import { ListView, Search, useSearch } from "@sembark-travel/ui-list"
import { CodeChip } from "../HotelOtaMealPlans"
import { hotelOtaRatePlansXHR, TOtaRatePlan } from "./store"

export function HotelOtaRatePlans({ hotelId }: { hotelId: number }) {
	const [params, setParams] = useSearch<Record<string, unknown>>()
	return (
		<Search
			initialParams={params}
			onSearch={(newParams) => setParams({ ...newParams, page: 1 })}
			title="Rate Plans"
			placeholder="Search"
		>
			<ListView<TOtaRatePlan>
				pageKey={`hotel-${hotelId}-ota-rate-plans`}
				fetch={(xhr, params) =>
					hotelOtaRatePlansXHR(xhr).getOtaRatePlans(hotelId, params)
				}
				params={params}
				onPageChange={(page) => setParams({ ...params, page })}
			>
				{({ items }) => <OtaRatePlansTable ratePlans={items} />}
			</ListView>
		</Search>
	)
}

function OtaRatePlansTable({ ratePlans }: { ratePlans: Array<TOtaRatePlan> }) {
	return (
		<Table
			bordered
			responsive
			headers={["Name", "Room Type", "Meal Plan"]}
			rows={ratePlans.map((ratePlan) => [
				<Inline gap="2" alignItems="center">
					<Text fontWeight="semibold">{ratePlan.name}</Text>
					<CodeChip code={String(ratePlan.id)} />
				</Inline>,
				<Text>{ratePlan.ota_room_type?.name || "-"}</Text>,
				<Text>{ratePlan.ota_meal_plan?.name || "-"}</Text>,
			])}
		/>
	)
}
